export default "__VITE_ASSET__yVM6PmQR__"